import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const logo = '/images/logo.png';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { name: '首页', href: '#home' },
    { name: '关于我们', href: '#about' },
    { name: '核心业务', href: '#business' },
    { name: '技术实力', href: '#technology' },
    { name: '发展历程', href: '#history' },
    { name: '联系我们', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-2 sm:space-x-3">
            <img src={logo} alt="越亘科技" className="h-8 sm:h-12 w-auto" />
            <div className="hidden sm:block">
              <div className={`transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                越亘科技
              </div>
              <div className={`text-xs ${isScrolled ? 'text-orange-600' : 'text-yellow-400'}`}>YUEGEEN TECHNOLOGY</div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={`transition-colors hover:text-orange-600 ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {item.name}
              </a>
            ))}
            <a
              href="#contact"
              className="px-6 py-2 rounded-full bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white hover:shadow-lg transition-all"
            >
              咨询服务
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 ${isScrolled ? 'text-gray-900' : 'text-white'}`}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <nav className="px-4 py-4 space-y-3">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-2 text-gray-700 hover:text-orange-600 transition-colors"
              >
                {item.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-2 px-4 text-center rounded-full bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white"
            >
              咨询服务
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}